import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class MinBulkUnitWeightGamaMinCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (MinBulkUnitWeightGamaMinCalculationMethodModel._instance == null) MinBulkUnitWeightGamaMinCalculationMethodModel._instance = new MinBulkUnitWeightGamaMinCalculationMethodModel(authManager);
        return MinBulkUnitWeightGamaMinCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/min-bulk-unit-weight-gama-min-calculation-methods', 'geo-sections/min-bulk-unit-weight-gama-min-calculation-methods/codelist');

        this.entityName = 'geo-sections.MinBulkUnitWeightGamaMinCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Min Bulk Unit Weight Gama Min Calc Method';
        this.setLabel = 'Min Bulk Unit Weight Gama Min Calc Methods';

        this.browser = {
            name: 'default-geo-sections-minbulkunitweightgamamincalculationmethod-browser',
            moduleName: 'default-geo-sections-minbulkunitweightgamamincalculationmethod-browser',
            moduleTitle: 'Min Bulk Unit Weight Gama Min Calc Methods',
            moduleStateSlotName: 'default-geo-sections-minbulkunitweightgamamincalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-minbulkunitweightgamamincalculationmethod-editor',
            moduleName: 'default-geo-sections-minbulkunitweightgamamincalculationmethod-editor',
            moduleTitle: 'Min Bulk Unit Weight Gama Min Calc Method',
            moduleStateSlotName: 'default-geo-sections-minbulkunitweightgamamincalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
